document.addEventListener("DOMContentLoaded", (event) => {

    var $ = require('jquery');

    //search within dc
    let searchButton = document.getElementById('dc-search');
    let searchtitle = document.getElementById('search-title');
    let urlPara = document.getElementById('url-para');
    let resetsearchdc = document.getElementById('reset-search-dc');

    const isDW = document.getElementById('downloadcenter-select');

    function setajaxDwText(id) {
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                cat: id,
                action: 'dw_text',
            },
            success: function (res) {
                $('#dw-custom').html(res);
            }
        })
    }


    function setajaxPills(id) {
        if (parseInt(id) === 71) {
            $('.file-specific-filters').css('display', 'flex');
        } else {
            $('.file-specific-filters').css('display', 'none');
        }

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                cat: id,
                action: 'filter_kachel',
            },
            success: function (res) {
                $('#dw-pills').html(res);
                $('#dw-pills li:first-child button').click();
            }
        })
    }

    //ajax für Hauptkacheln im Downloadcenter
    function setajaxDW(id) {
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                cat: id,
                action: 'filter_pills',
            },
            success: function (res) {
                $('#dw-content').html(res);
            }
        })
    }

    function setajaxDWsearchterm(id, term) {
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                cat: id,
                s: term,
                action: 'filter_pills_term',
            },
            success: function (res) {
                $('#dw-content').html(res);
            }
        })
    }

    function removeActive(EleList) {
        EleList.forEach(ele => {
            ele.classList.remove('active');
        })
    }

    function keywordsearchParameter() {

        searchKey = document.getElementById('search-para');
        if (searchKey.value == "") {
            searchtitle.innerHTML = "";
            resetsearchdc.classList.add('hidden');
        } else {
            searchtitle.innerHTML = 'Suche nach: "' + searchKey.value + '"';
            resetsearchdc.classList.remove('hidden');
        }


        //findout cat for search

        //if pills are set and one pill is set as active
        let pills = document.querySelectorAll('[data-secindex]');

        let activeElement = false;
        let isactive = false;

        if (pills) {
            pills.forEach((element) => {
                if (element.classList.contains('active')) {
                    isactive = true;
                    activeElement = element;
                }
            });
        }

        let catid = false;

        if (pills && isactive && activeElement) {

            catid = activeElement.dataset.secindex;
        } else {
            //if pills are not set and active

            let kacheln = document.querySelectorAll('[data-mainindex]');

            kacheln.forEach((element) => {
                if (element.classList.contains('active')) {
                    catid = element.dataset.mainindex;
                }
            });


        }
        let searchterm = searchKey.value;

        if (searchterm && catid) {
            setajaxDWsearchterm(catid, searchterm);

            disallowedTooltip(".disallowed", ".disallowed-tooltip");
            disallowedTooltip(".disallowed-for-you", ".disallowed-for-you-tooltip");
        } else {
            if (catid && !searchterm) {
                setajaxDW(catid);
            }
        }
    }

    function removesearchvalues() {
        if (typeof searchKey !== 'undefined') {
            searchKey.value = "";
        }
        if (searchtitle) {
            searchtitle.innerHTML = "";
        }
        resetsearchdc.classList.add('hidden');
    }

    //open dc with url
    if (urlPara) {
        let indexId = urlPara.dataset.mainindex;
        setajaxDwText(indexId);
        setajaxPills(indexId);
        setajaxDW(indexId);
        //set kachel as active
        $("[data-mainindex='" + indexId + "']")[1].classList.add('active');
    }


    if (searchButton) {
        searchButton.addEventListener('click', () => {
            keywordsearchParameter();
        });
        resetsearchdc.addEventListener('click', () => {
            removesearchvalues();
            keywordsearchParameter();
        });
    }


    //normal dc
    if (isDW) {

        let kachelButtons = Array.from(document.querySelectorAll('[data-mainindex]'));
        let dwContent = document.getElementById('dw-content');

        kachelButtons.forEach(kachel => {
            kachel.addEventListener('click', () => {

                if(kachel.classList.contains('toggle-login')){
                    return;
                }

                removesearchvalues();

                removeActive(kachelButtons);
                kachel.classList.add('active');

                let indexId = kachel.dataset.mainindex;
                setajaxDwText(indexId);
                setajaxPills(indexId);
                setajaxDW(indexId);

                disallowedTooltip(".disallowed", ".disallowed-tooltip");
                disallowedTooltip(".disallowed-for-you", ".disallowed-for-you-tooltip");

            });
        });


        let loader = document.getElementById('loading');
        $(document).on({
            ajaxStart: function () {

                dwContent.classList.add('hidden');
                loader.classList.add('loader');


            },
            ajaxStop: function () {

                dwContent.classList.remove('hidden');
                loader.classList.remove('loader');


                let allButtons = Array.from(document.querySelectorAll('[data-primaryindex]'));
                let pillButtons = Array.from(document.querySelectorAll('[data-secindex]'));

                pillButtons.forEach(pill => {
                    pill.addEventListener('click', () => {

                        removesearchvalues();


                        removeActive(pillButtons);
                        removeActive(allButtons);
                        pill.classList.add('active');

                        let indexId = pill.dataset.secindex;
                        setajaxDW(indexId);
                    });
                });

                allButtons.forEach(button => {
                    button.addEventListener('click', () => {

                        removeActive(allButtons);
                        removeActive(pillButtons);
                        button.classList.add('active');

                        let indexId = button.dataset.primaryindex;
                        setajaxDW(indexId);
                    });
                });

                let search = document.getElementById('searchform');
                search.classList.remove('hidden');

                disallowedTooltip(".disallowed", ".disallowed-tooltip");
                disallowedTooltip(".disallowed-for-you", ".disallowed-for-you-tooltip");

                document.getElementById('dw-custom').scrollIntoView({ behavior: "smooth"});
            }
        });

    }

    document.querySelectorAll('.toggle-login').forEach(downloadLoginButton => {
        const loginForm = document.getElementById('loginform-container');

        downloadLoginButton.addEventListener('click', () => {
            loginForm.classList.add('display');
        });
    });

    $(document).on('click', 'button[data-permissiongroup]:not([disabled])', function () {
        let filterPill = $(this);

        let pillButtons = Array.from(document.querySelectorAll('button[data-permissiongroup]'));
        removeActive(pillButtons);
        $(this).addClass('active');

        runDocumentManagerFilter();
    });

    if (isDW) {
        $('[name="yearmonthfilter"]').change(function () {
            keywordsearchParameter();
        });
    
        $('[name="filetypefilter"]').change(function () {
            keywordsearchParameter();
        });
    
        $('[name="search"]').keyup(function () {
            keywordsearchParameter();
        });    
    }else{
        $('[name="yearmonthfilter"]').change(function () {
            runDocumentManagerFilter();
        });
    
        $('[name="filetypefilter"]').change(function () {
            runDocumentManagerFilter();
        });
    
        $('[name="search"]').keyup(function () {
            runDocumentManagerFilter();
            console.log('test');
        });
    
    }
    
    function runDocumentManagerFilter() {
        $.post('/wp-admin/admin-ajax.php', {
            yearmonth: $('[name="yearmonthfilter"]').val(),
            filetype: $('[name="filetypefilter"]').val(),
            searchstring: $('#search-para').val(),
            permissiongroup: $('button[data-permissiongroup].active').attr('data-permissiongroup'),
            action: 'get_documentmanager_files',
        }, function (res) {
            $('#dw-content').html(res);

            $('#dw-content table').each(function () {
                initTablePagination($(this), 10);
            });
        });
    }

    function initTablePagination(table, itemsPerPage){
        const content = table.parent();
        let currentPage = 0;
        const items = Array.from(content.find('tr')).slice(1);

        function showPage(page) {
            const startIndex = page * itemsPerPage;
            const endIndex = startIndex + itemsPerPage;
            items.forEach((item, index) => {
                item.classList.toggle('hidden', index < startIndex || index >= endIndex);
            });

            document.getElementById('dw-custom').scrollIntoView({ behavior: "smooth"});

            updateActiveButtonStates();
        }

        function createPageButtons() {
            const totalPages = Math.ceil(items.length / itemsPerPage);
            const paginationContainer = document.createElement('div');
            const paginationDiv = document.body.appendChild(paginationContainer);
            paginationContainer.classList.add('pagination');

            // Add page buttons
            for (let i = 0; i < totalPages; i++) {
                const pageButton = document.createElement('button');
                pageButton.textContent = i + 1;
                pageButton.addEventListener('click', () => {
                    currentPage = i;
                    showPage(currentPage);
                    updateActiveButtonStates();
                });

                content.append(paginationContainer);
                paginationDiv.append(pageButton);
            }
        }

        function updateActiveButtonStates() {
            const pageButtons = document.querySelectorAll('.pagination button');
            pageButtons.forEach((button, index) => {
                if (index === currentPage) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            });
        }

        createPageButtons();
        showPage(currentPage);
    }
});